.container {
  margin-top: 12rem;
  padding-bottom: 13.75rem;

  h2 {
    font-style: normal;
    font-weight: 400;
    font-size: 1.563rem;
  }

  h4 {
    margin-top: 4.563rem;

    font-style: normal;
    font-weight: 400;
    font-size: 0.938rem;
    line-height: 1.688rem;
  }

  a {
    color: #fff;
    text-decoration: none;
  }

  ul {
    display: flex;
    flex-direction: row;
    margin-top: 1.938rem;

    gap: 1.688rem;
    list-style: none;
  }
}
